import React, { useEffect } from 'react';

import { HUBSPOT_FORM_SCRIPT } from 'config.js';

export default function HubspotForm({ target, hubspotForm, onFormSubmitted = null }) {
  const createHubspotForm = () => {
    if (!window.hbspt) {
      setTimeout(createHubspotForm, 100);
      return;
    }

    window.hbspt.forms.create({
      target: `#${target}`,
      ...hubspotForm,
      ...(onFormSubmitted && { onFormSubmitted }),
    });
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = HUBSPOT_FORM_SCRIPT;
    script.onload = createHubspotForm;
    document.head.appendChild(script);
  }, []);

  return <div id={target} />;
}
